import React from "react";
import { Fab } from "@mui/material";
import { Icon } from "@/components/Icon";

// Scroll indicator component
export const ScrollIndicator: React.FC = () => {
  const [showIndicator, setShowIndicator] = React.useState(false);

  React.useEffect(() => {
    const checkScrollPosition = () => {
      // Find the modal's scrollable content area
      const modalDialog = document.querySelector("[role=\"dialog\"]");
      const modalContent = modalDialog?.querySelector(".MuiDialogContent-root") ||
                          modalDialog?.querySelector("[class*=\"DialogContent\"]") ||
                          modalDialog?.querySelector(".MuiDialog-paper") ||
                          modalDialog;

      if (!modalContent) return;

      const scrollTop = modalContent.scrollTop || 0;
      const scrollHeight = modalContent.scrollHeight;
      const clientHeight = modalContent.clientHeight;

      // Show indicator if there's content below the fold and user hasn't scrolled much
      const hasContentBelow = scrollHeight > clientHeight + scrollTop + 50;
      const hasScrolledDown = scrollTop > 100;

      setShowIndicator(hasContentBelow && !hasScrolledDown);
    };

    // Check on mount with a small delay to ensure DOM is ready
    const timeoutId = setTimeout(checkScrollPosition, 100);

    // Find the scrollable container
    const modalDialog = document.querySelector("[role=\"dialog\"]");
    const modalContent = modalDialog?.querySelector(".MuiDialogContent-root") ||
                        modalDialog?.querySelector("[class*=\"DialogContent\"]") ||
                        modalDialog?.querySelector(".MuiDialog-paper") ||
                        modalDialog;

    if (modalContent) {
      modalContent.addEventListener("scroll", checkScrollPosition);
      window.addEventListener("resize", checkScrollPosition);
    }

    return () => {
      clearTimeout(timeoutId);
      if (modalContent) {
        modalContent.removeEventListener("scroll", checkScrollPosition);
        window.removeEventListener("resize", checkScrollPosition);
      }
    };
  }, []);

  if (!showIndicator) return null;

  return (
    <Fab
      size="small"
      sx={{
        position: "absolute",
        bottom: 40,
        right: "50%",
        transform: "translateX(50%)",
        zIndex: 1000,
        backgroundColor: "primary.main",
        color: "white",
        animation: "bounce 2s infinite",
        "@keyframes bounce": {
          "0%, 20%, 50%, 80%, 100%": {
            transform: "translateX(50%) translateY(0)",
          },
          "40%": {
            transform: "translateX(50%) translateY(-10px)",
          },
          "60%": {
            transform: "translateX(50%) translateY(-5px)",
          },
        },
        "&:hover": {
          "& svg": {
            color: "primary.main",
          },
        },
      }}
      onClick={() => {
        const modalDialog = document.querySelector("[role=\"dialog\"]");
        const modalContent = modalDialog?.querySelector(".MuiDialogContent-root") ||
                            modalDialog?.querySelector("[class*=\"DialogContent\"]") ||
                            modalDialog?.querySelector(".MuiDialog-paper") ||
                            modalDialog;

        if (modalContent) {
          const scrollAmount = modalContent.clientHeight * 0.8;
          modalContent.scrollBy({ top: scrollAmount, behavior: "smooth" });
        }
      }}
    >
      <Icon icon="chevrondown" />
    </Fab>
  );
};

